<template>
  <v-row dense class="DutyActivityNoLineEnd_RhB">
    <v-col cols="12"></v-col>
    <!--    <v-col cols="1">-->
    <!--      <time-line-point small :cellHeight="30" :themeName="themeName" :topConnection="false" :bottomConnection="false"></time-line-point>-->
    <!--    </v-col>-->
    <!--    <v-col cols="8">{{ dutyActivity.note }}</v-col>-->
    <!--    <v-col cols="3">{{ time(dutyActivity.toMinutesAfterMidnight) }}</v-col>-->
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '@/components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityNoLineEnd_RhB',
  components: {},
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
